import { useNavigate } from "react-router-dom";
import { ChevronLeft, Heart, MapPin, BadgeCheck } from "lucide-react";

export default function StoreAbout() {
  const nav = useNavigate();
  return (
    <div className="space-y-4 animate-fade-up">
      <div className="flex items-center justify-between">
        <button onClick={() => nav(-1)} className="w-9 h-9 rounded-full bg-white border border-blush-soft flex items-center justify-center">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <h1 className="font-semibold">Tentang Kiyana</h1>
        <div className="w-9" />
      </div>

      <div className="bg-gradient-to-br from-[#C4707F] to-[#A85B6A] rounded-2xl p-6 text-white text-center">
        <div className="font-serif-fashion text-3xl tracking-[0.25em]">KIYANA</div>
        <div className="text-[10px] tracking-[0.2em] opacity-85 mt-1">by Cirebon Cloth</div>
        <p className="text-xs mt-4 opacity-90 leading-relaxed">Outfit lucu, percaya diri setiap hari ✨</p>
      </div>

      <div className="bg-white rounded-2xl border border-blush-soft p-4">
        <div className="text-sm font-semibold mb-2">Cerita Kami</div>
        <p className="text-xs text-cocoa-muted leading-relaxed">
          Kiyana by Cirebon Cloth lahir dari Cirebon dengan cinta pada kain lokal dan desain feminin modern.
          Setiap koleksi dibuat dengan bahan berkualitas yang nyaman dipakai harian — dari atasan, dress,
          hingga koleksi batik Cirebon modern seperti motif Megamendung. Misi kami: membuat setiap perempuan
          Indonesia tampil manis dan percaya diri tanpa harus mahal.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="bg-white rounded-2xl border border-blush-soft p-4">
          <BadgeCheck className="w-5 h-5 text-brand mb-2" />
          <div className="text-xs font-semibold">Bahan Premium</div>
          <div className="text-[11px] text-cocoa-muted mt-1">Quality control berlapis sebelum dikirim.</div>
        </div>
        <div className="bg-white rounded-2xl border border-blush-soft p-4">
          <Heart className="w-5 h-5 text-brand mb-2" />
          <div className="text-xs font-semibold">Dibuat dengan Cinta</div>
          <div className="text-[11px] text-cocoa-muted mt-1">Produksi lokal Cirebon, memberdayakan penjahit lokal.</div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-blush-soft p-4">
        <div className="text-sm font-semibold mb-2 flex items-center gap-2"><MapPin className="w-4 h-4 text-brand" /> Toko Offline</div>
        <p className="text-xs text-cocoa-muted leading-relaxed">
          Showroom Kiyana by Cirebon Cloth<br />
          Kota Cirebon, Jawa Barat<br />
          Buka setiap hari 09.00–20.00 WIB
        </p>
      </div>
    </div>
  );
}
